import { disableScroll, enableScroll } from '@/shared/helpers/helpers';

export class HeaderSearchMobile {
	element = document.querySelector('.header-search-mobile');
	activeClass = 'header-search-mobile--active';

	constructor() {
		if (!this.element) return;
		this.init();
	}

	open = () => {
		this.element.classList.add(this.activeClass);
		disableScroll();
	};

	close = () => {
		this.element.classList.remove(this.activeClass);
		enableScroll();
	};

	openHandler = () => this.open();
	clickHandler = ({ target }) => {
		if (target === this.element || target.closest('.header-search-mobile__close')) this.close();
	};

	init = () => {
		window.addEventListener('mobileSearchOpen', this.openHandler);
		this.element.addEventListener('click', this.clickHandler);
	};
}
